const mainTheme = {
  black100: '#000',
  black75: '#4A4A4A',
  hoverColorGray: "#F0F2F7",
  whiteBackground: "#fff",
  secondaryGrayColor: "#E4E7EF",
  interactionColor: "#5d762d",
  interactionColorDark: "#40521F",
  primaryColor: "#688b2d",
  primaryHover: "#5d762d",
  borderColor: "#85a83e",
  secondaryColor: "#666c6f",
  redColor: "#666c6f",
  customStylesSelectBackground: "#40521F",
  logo: require("images/STP_BI_Logo.png"),
  logoWhite: require("images/STP_BI_Logo.png"),
  logoOrange: require("images/STP_BI_Logo.png"),
  appTitle: "BIZaround",
};

export default mainTheme;
